/**
 * @param {Document|HTMLElement} root
 */
export function lazyLoadCollapsibleTextComponents(root = document) {
    const collapsibleOverflowTextComponents = root.querySelectorAll('[data-collapsible-overflow-text]');

    if (!collapsibleOverflowTextComponents.length) {
        return;
    }

    void import('../components/collapsibleOverflowText.js').then(
        ({initializeCollapsibleOverflowText}) => initializeCollapsibleOverflowText(root)
    );
}
